export default function SmartImage(src, option, bypass = false) {
  let image = "https://a.storyblok.com/f/156499/1920x1080/31caf140be/darktide-keyart-1920x1080.png";

  if (src) {
    image = src;
  }

  let size;
  if (!option) {
    size = "";
  } else {
    size = option + "/";
  }

  //let imageService = "https://otherthings.netlify.app/images/";
  let imageService = "//img2.storyblok.com/";
  let path = image.replace("https://a.storyblok.com/", "");

  return imageService + size + path;
}
